module.exports = __webpack_public_path__ + "img/sakeasiatisch.a03d9545.jpg";